module.exports = __webpack_public_path__ + "img/who-is-suitable_2_1920.8fdbd51.jpg";